import { ReactElement } from 'react';

import { CustomerLayout } from '~/layouts';

import { PricingPlansContent } from './PricingPlansContent';

export const PricingPlans = (): ReactElement => (
  <CustomerLayout>
    <PricingPlansContent variant="pricing" />
  </CustomerLayout>
);
